import bilAPI from "../api";

export const getSubtopics = ({ params: { topic, search, page, page_size }, signal }) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/questions/subtopics/`, { params: { topic, search, page, page_size }, signal })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("axios error");
        });
    } catch (error) {
      reject("system error");
    }
  });
};
